import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { getAideCopropriete } from '../../../../config/aides-coproprietes';

export default function CeeCollectifsPage() {
  const aide = getAideCopropriete('cee-collectifs');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="coproprietes" />;
}
